/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Busy_Lost_Bison_JestInputs */

const fr_busy_lost_bison_jest = /** @type {(inputs: Busy_Lost_Bison_JestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours`)
};

/**

* @param {Busy_Lost_Bison_JestInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const busy_lost_bison_jest = /** @type {((inputs?: Busy_Lost_Bison_JestInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Busy_Lost_Bison_JestInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_busy_lost_bison_jest(inputs)
});